export default {
    // 模块名称
    carPatrolBlack: {
        // 按钮类
        button: {
            add: '新增',
            edit: '修改',
            delete: '删除',
            view: '详情',
            cancel:'取消',
            confirm:'确定',
            save:'保存',
            close:'关闭',
            create:'创建',
            search:'查询',
            reset:'重置',
            checkAll:'全选',
            return: '返回',
            skip: '研判'
        },
        // 文字标签类
        label: {
            blackName:'名单组名称',
            describe:'描述',
            number:'车牌',
            owner:'车主',
            createDate:'创建时间',
            remark:'备注',
            picture:'车辆图片',
            blackList:'名单组列表',
            type:'车辆类型',
            color:'车身颜色',
            unlimit: '不限',
        },
        // 提示类
        placeholder: {
            nameFilter:'请输入名称进行过滤',
            blackName:'请输入名单组名称',
            describe:'请输入描述',
            blackList:'请输入名单组列表',
            number:'请输入车牌',
            owner:'请输入车主姓名',
            color:'请选择车身颜色',
            type:'请选择车辆类型',
            startTime: '开始时间',
            endTime: '结束时间'
        },
        // 消息类
        message: {
            deleteNameList: '选择要删除的名单',
            choseNameList: '删除选中名单, 是否继续?',
            choseNameOne: '删除该名单, 是否继续?',
            choseGroup: '选择名单组',
            deleteList: '删除名单组, 是否继续?',
            deleteOk: '删除成功',
            deleteNo: '删除失败',
            noChoseList: '无选中名单组',
            searchWarn:'车辆黑名单查询时间跨度不超过30天!',
            upWarn:'最大上传1张图片',
            formatWarn:'图片格式不正确, 请重新选择',
            sizeWarn:'图片大小不能超过4M',
            failUp:'图片上传失败',
            selectlist: '请选择黑名单组列表',
            inputno: '请输入车牌',
            carformat: '车牌格式错误',
            ownerformat: '车主格式错误'
        },
        // 标题类
        title: {
            addOk: '新增成功',
            editOk: '修改成功',
            remind:'提示',
            nameList:'名单组详情',
            addBlack:'新增名单组',
            editBlack:'修改名单组',
            blackList:'黑名单',
            whiteBlack:'白名单',
            addCars: '车辆名单新增',
            editCars: '车辆名单修改'
        }
    }
}